<template>
  <div class="container">
    <Header></Header>
    <Userheader></Userheader>
    <div>
      <div
        class="wrap d-flex justify-content-center"
        :class="isIphoneX ? 'isIphoneX' : ''"
      >
        <Usernavleft></Usernavleft>
        <!-- 商品 -->
        <div class="return_content">
          <div class="head_title" v-if="type==1">申请退货退款</div>
          <div class="head_title" v-if="type==3">申请退款</div>
          <div class="goods-box">
            <div class="store">
              <img
                class="store-img"
                mode="aspectFill"
                v-if="mch_logo"
                :src="mch_logo"
              />
              <div class="store-name">{{ mch_name }}</div>
              <img
                class="store-icon"
                src="../../assets/return_img/more_icon.png"
              />
            </div>
            <div class="goods" v-for="(item, index) in goods" :key="index">
              <img class="goods-img" :src="item.goods_pic" mode="aspectFill" />
              <div class="goods-info">
                <div class="goods-txt">
                  <div class="goods-name">{{ item.name }}</div>
                  <div class="goods-attr">
                    <div v-for="(itemAttr, b) in item.attr" :key="b">
                      {{ itemAttr.attr_name }}
                      <template v-if="index < item.attr.length - 1">;</template>
                    </div>
                  </div>
                </div>
                <div class="goods-number">
                  <div class="goods-price">
                    <span>¥</span> {{ item.total_price }}
                  </div>
                  <div class="goods-num">x{{ item.num }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 退款金额 -->
          <div class="refund-price">
            <span>退款金额</span>
            <div><span>¥</span>{{ refund_price }}</div>
          </div>
          <!-- 选择退款原因 -->
          <div class="reason">
            <div class="reason-title">退款原因：</div>
            <el-select
              v-model="reason_value"
              placeholder="请选择原因"
              @change="slectoption"
            >
              <!-- <div class="picker">{{ reason[reason_index].name }}</div> -->
              <el-option
                v-for="(item, index) in reason"
                :key="index"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
          <!-- 具体原因 -->
          <div class="refund">
            <div class="refund-title">具体原因</div>
            <textarea
              placeholder="请描述申请售后的具体原因"
              placeholder-style="color:#999999;"
              maxlength="-1"
              v-model="desc"
            ></textarea>
            <!-- <div class="refund-img-box" v-if="type == 1">
              <div
                class="refund-imgs"
                v-for="(item, index) in pic_list"
                :key="index"
              >
                <img :src="item" class="refund-img" />
                <img
                  src="../../assets/return_img/del.png"
                  class="refund-img-del"
                  @click.stop="deleteImg(index)"
                />
              </div>
              <div
                class="refund-upload"
                @click="uploadImg"
                v-if="pic_list.length < 5"
              >
                <div>
                  <img src="../../assets/return_img/pirce.png" />
                  <span>上传凭证</span>
                </div>
              </div>
            </div> -->
            <div class="voucher">
              <p class="voucher_title">上传凭证</p>
              <div class="refund-img-box">
                <el-upload
                  list-type="picture-card"
                  :auto-upload="false"
                  class="avatar-uploader"
                  action="String"
                  ref="eleupload"
                  :on-change="
                    (file, fileList) => {
                      handleChange(file, fileList);
                    }
                  "
                  :on-remove="
                    (file, fileList) => {
                      handleRemove(file, fileList);
                    }
                  "
                  accept="image/*"
                  :limit="imgLimit"
                  :file-list="productImgs"
                  :before-upload="beforeAvatarUpload"
                  :on-exceed="handleExceed"
                  :on-error="imgUploadError"
                >
                  <div class="refund-upload" v-if="uploadfile.length < 5">
                    <div>
                      <img src="../../assets/return_img/pirce.png" />
                      <span>上传凭证</span>
                    </div>
                  </div>
                  <!-- <div slot="file" slot-scope="{ file }">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt=""
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                    </span>
                  </div> -->
                </el-upload>
              </div>
            </div>
            <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog> -->
          </div>
          <div class="refund-btn">
            <div class="btn" @click="btnRefund"  v-loading.fullscreen.lock="fullscreenLoading">完成</div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      isIphoneX: "",
      order_id: "", //订单id
      order_detail_id: "", //子订单id
      type: "", //1=退款退货 3=退款
      goods: {}, //商品
      mch_logo: "", //店铺logo
      mch_name: "", //店铺名称
      refund_price: "", //退款金额
      reason: [], //退款reason
      reason_index: 0, //选择退款原因
      reason_value: "",
      pic_list: [],
      uploaded_pic_list: [],
      desc: "", //具体原因
      back_num: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgLimit: 5,
      productImgs: [],
      uploadfile: [],
      fileList: [], //上传的file
      fullscreenLoading:false,//加载中
    };
  },
  methods: {
    slectoption(value) {
      console.log(value);
    },
    // 选择图片
    handleChange(file, fileList) {
      //判断其是否有重名文件
      let repeat_judge = this.productImgs.find((item) => {
        return item.name == file.name;
      });
      if (repeat_judge) {
        fileList.pop();
        let msg_repeat = `您上传的${file.name},该文件有重名文件，请您重新上传。`;
        this.$message({
          type: "none",
          message: msg_repeat,
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      this.productImgs = JSON.parse(JSON.stringify(fileList));
      this.fileList.push(file);
    },
    // 删除图片调用
    handleRemove(file, fileList) {
      this.productImgs = JSON.parse(JSON.stringify(fileList));
      this.fileList.forEach((item, index) => {
        if (item.name == file.name) {
          this.fileList.splice(index, 1);
          // this.uploadfile.splice(index, 1);
        }
      });
    },
    // 图片上传失败调用
    imgUploadError(err, file, fileList) {
      this.$message.error("上传图片失败!");
    },
    //文件上传之前调用做一些拦截限制
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error("上传图片不能超过5张!");
    },
    // 获取数据
    getRefundPreview() {
      let that = this;
      let type = that.type;
      this.$api
        .refund_preview({
          order_id: that.order_id,
          type: that.type,
          order_detail_id: that.order_detail_id,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.goods = res.data;
            this.mch_logo = res.mch_logo;
            this.mch_name = res.mch_name;
            this.reason = res.reason;
            this.refund_price = res.refund_price;
          } else {
            this.$message({
              type: "none",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //删除图片
    deleteImg() {},
    async fileup(){
      for(var i=0;i<this.fileList.length;i++){
         const formData = new FormData();
        // console.log(file.raw);
        formData.append("image", this.fileList[i].raw);
        let config = {
          headers: {
            "Content-Type": "mutipart/form-data",
          },
        };
        let res=await this.$api.uploadImage(formData, config);
        console.log(res);
        if(res.code==0){
          console.log(res.data.url);
          this.uploadfile.push(res.data.url);
        }else{
          this.common.message(this, res);
        }
      }
    },
    //上传图片
    async uploadImg() {
      await this.fileup();
      await this.submitRefund();
    },
    //完成
    btnRefund() {
      var that = this;
      if (this.desc == "") {
        this.$message({
          type: "none",
          message: "请输入具体原因",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if(this.reason_value==''){
         this.$message({
          type: "none",
          message: "请选择申请原因",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if (this.fileList.length > 0) {
        this.fullscreenLoading =true;
        this.uploadImg();
      } else {
        this.submitRefund();
      }
    },
    //提交数据
    submitRefund() {
      // console.log(this.uploadfile )
        this.fullscreenLoading=false;
      let file=JSON.stringify(this.uploadfile)
      var that = this;
      this.$api
        .alirefund({
          order_id: that.order_id,
          type: that.type,
          order_detail_id: that.order_detail_id,
          pic_list: file,
          desc: this.desc,
          reason_id: this.reason_value,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: res.msg,
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          setTimeout(function () {
            if (that.type == 3) {
              that.$router.go(-1);
            } else if (that.type == 1) {
              that.$router.go(-2);
            }
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
          this.common.message(this, err);
        });
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //识别textarea里的换行和空格
    getFormatCode(strValue) {
      return strValue
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\s/g, "&nbsp;");
    },
  },
  created() {
    this.type = this.$route.query.type;
    if (this.$route.query.order_id) {
      this.order_id = this.$route.query.order_id;
    }
    if (this.$route.query.back_num) {
      this.back_num = this.$route.query.back_num;
    }
    if (this.$route.query.order_detail_id) {
      this.order_detail_id = this.$route.query.order_detail_id;
    }
    this.getRefundPreview();
  },
};
</script>
<style lang="scss" scoped>
.head_title{
  text-align: center;
  line-height: 50px;
  font-size: 25px;
  color: #ff4544;
}
::v-deep .el-upload--picture-card {
  border: none;
}
.refund-img-box >>> .el-upload {
  border: none;
}
.container {
  width: 100%;
  height: 100%;
  .return_content {
    // max-width: 510px;
    width: 990px;
    float: right;
    background: #fff;
    padding-bottom: 15px;
  }
  .voucher {
    margin-top: 20px;
    .voucher_title {
      font-size: 16px;
      line-height: 30px;
    }
  }
  .container:after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: rgba(0, 0, 0, 0.03);
  }
  .wrap {
    padding: 24px 24px 122px;
    background: #f2f2f2;
  }
  .wrap.isIphoneX {
    padding-bottom: 165px;
  }
  .goods-box {
    background: #fff;
    padding: 0 20px;
    border-radius: 14px;
    overflow: hidden;
  }
  .store {
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
  }
  .store-img {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: #cccccc;
  }
  .store-name {
    color: #333333;
    font-size: 14px;
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 8px;
  }
  .store-icon {
    width: 28px;
    height: 28px;
  }
  .goods {
    padding: 16px 0 32px;
    display: flex;
    border-bottom: 2px solid #ebebeb;
  }
  .goods:last-child {
    border-bottom: 0;
  }
  .goods-img {
    width: 180px;
    height: 180px;
    border-radius: 14px;
    background: #cccccc;
  }
  .goods-info {
    min-width: 0;
    flex: 1;
    display: flex;
  }
  .goods-txt {
    min-width: 0;
    flex: 1;
    padding: 0 20px 0 24px;
  }
  .goods-name {
    font-size:16px;
    color: #333333;
    line-height: 38px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goods-attr {
    font-size: 24px;
    color: #666666;
    margin-top: 14px;
    div {
      display: inline-block;
    }
  }
  .goods-integral {
    font-size: 22px;
    line-height: 22px;
    color: #999999;
    margin-top: 14px;
  }
  .goods-number {
    text-align: right;
  }
  .goods-price {
    font-size: 25px;
    line-height: 28px;
    display: flex;
    color: #333333;
    align-items: flex-end;
  }
  .goods-price span {
    font-size: 20px;
    padding-right: 4px;
  }
  .goods-num {
    font-size: 18px;
    line-height: 24px;
    color: #999999;
    margin-top: 6px;
  }
  .goods-total-price {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 24px;
    color: #333;
  }
  .goods-total-price .num {
    color: #666666;
    margin-right: 10px;
  }
  .goods-total-price .total-price {
    display: flex;
    align-items: flex-end;
  }
  .goods-total-price .total-price text {
    font-size: 20px;
    padding-right: 4px;
  }
  .goods-total-price .total-price view {
    font-size: 28px;
    line-height: 28px;
  }

  .refund-price {
    height: 88px;
    border-radius: 14px;
    background: #fff;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 28px;
    line-height: 28px;
  }
  .refund-price view {
    flex: 1;
    min-width: 0;
    justify-content: flex-end;
    color: #ff4544;
    display: flex;
    align-items: flex-end;
  }
  .refund-price view text {
    font-size: 20px;
    padding-right: 4px;
  }

  .refund {
    background: #fff;
    padding: 0 20px;
    border-radius: 14px;
    overflow: hidden;
    margin-top: 20px;
    padding-bottom: 43px;
  }
  .refund-title {
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #333333;
  }
  .refund textarea {
    display: block;
    width: 100%;
    height: 144px;
    box-sizing: border-box;
    border-radius: 14px;
    background: #f0f0f0;
    font-size: 20px;
    resize: none;
    padding: 24px 16px;
    max-width: 300px;
    outline: none;
  }
  .refund-img-box {
    display: flex;
    flex-wrap: wrap;
  }
  .refund-imgs {
    width: 126px;
    height: 126px;
    margin-right: 8px;
    margin-top: 24px;
    border-radius: 14px;
    overflow: hidden;
    position: relative;
  }
  .refund-imgs:last-child {
    margin-right: 0;
  }
  .refund-img {
    width: 100%;
    height: 100%;
  }
  .refund-img-del {
    position: absolute;
    width: 44px;
    height: 44px;
    top: 0;
    right: 0;
  }
  .refund-upload {
    width: 148px;
    height: 148px;
    border-radius: 14px;
    border: 2px dashed rgba(208, 209, 212, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #999999;
    // margin-top: 24px;
    box-sizing: border-box;
  }
  .refund-upload image {
    width: 48px;
    height: 48px;
    display: block;
    margin: 0 auto;
  }
  .refund-upload text {
    line-height: 24px;
    margin-top: 10px;
    display: block;
  }

  .refund-btn {
    // position: fixed;
    width: 100%;

    box-sizing: border-box;
    // padding: 25px 24px;
    // left: 0;
    // bottom: 0;
    border-radius: 72px;
  }
  .refund-btn .btn {
    width: 30%;
    height: 72px;
    border-radius: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin: 0 auto;
    background: #f5f5f5;
    // color: #fff;
  }
  .container.isIphoneX .refund-btn {
    padding-bottom: 68px;
  }
  /* 选择退款原因 */
  .reason {
    background: #fff;
    // height: 88px;
    display: flex;
    padding: 0 20px;
    margin-top: 20px;
    border-radius: 14px;
    align-items: center;
    font-size: 28px;
    color: #333333;
  }
  .reason-title {
    font-size: 14px;
    color: #333333;
  }
  .reason picker {
    min-width: 0;
    flex: 1;
  }
  .reason picker .picker {
    display: flex;
    width: 100%;
    height: 88px;
    align-items: center;
  }
}
</style>